export const UpsellingHeadersDGG = [
    {
        id: 1,
        title: 'Firma',
        mouseOver: null
    },
    {
        id: 2,
        title: 'Closer',
        mouseOver: null
    },
    {
        id: 3,
        title: 'bAV',
        mouseOver: 'betriebliche Altersvorsorge'
    },
    {
        id: 4,
        title: 'CLS',
        mouseOver: 'Clearingstelle'
    },
    {
        id: 5,
        title: 'GehaltsExtras',
        mouseOver: 'GehaltsExtras'
    },
    {
        id: 6,
        title: 'bKV',
        mouseOver: 'betriebliche Krankenversicherung'
    },
    {
        id: 7,
        title: 'bBU',
        mouseOver: 'betriebliche Berufsunfähigkeit'
    },
    {
        id: 8,
        title: 'HRMT Pro',
        mouseOver: 'HR-MultiTool Pro'
    },
    // {
    //     id: 8,
    //     title: 'Upselling (Ja/Nein)'
    // },
    // {
    //     id: 8,
    //     title: 'NBG'
    // },

]
